export default function JobKeyLogo({ dark = false, className = "" }) {
  const ink = dark ? "#eef1f5" : "#14213d";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="jobkey-logo">
      <svg width="26" height="26" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#14213d" />
        <circle cx="25" cy="25" r="10" fill="none" stroke="#2dd4bf" strokeWidth="6" />
        <path
          d="M32 32 L48 48 M43 43 L51 35 M48 48 L55 41"
          stroke="#2dd4bf"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      <span className="font-display font-extrabold tracking-tight" style={{ color: ink }}>
        Job<span style={{ color: dark ? "#2dd4bf" : "#0f766e" }}>ky</span>
      </span>
    </span>
  );
}
